import { render, staticRenderFns } from "./Cup.vue?vue&type=template&id=2812f376&scoped=true&"
import script from "./Cup.vue?vue&type=script&lang=js&"
export * from "./Cup.vue?vue&type=script&lang=js&"
import style0 from "./Cup.vue?vue&type=style&index=0&id=2812f376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812f376",
  null
  
)

export default component.exports